import classNames from "classnames";
import { Stack } from "PFComponents/containers";
import { Tile } from "PFComponents/tile";
import { PropsWithChildren } from "react";

import css from "../kpi_events_list.module.scss";

type KPIEventTileBaseProps = PropsWithChildren<{
  loading?: boolean;
}>;

export const KPIEventTileBase = ({ loading, children }: KPIEventTileBaseProps) => (
  <Tile
    border
    variant="light"
    paddingVariant="lg"
    className={classNames(css.tile, { [css.loading]: loading })}
  >
    <Stack>{children}</Stack>
  </Tile>
);
